import NewTemplateComponent from "../new-template/new-template.component";
import { FirebaseFunctionsError } from '../../shared/customerrors';
const ACTIVE_FOLDER_STORAGE_KEY = 'fe_template_active_folder_id';

class FormTemplateListCtrl {
  constructor($window, $state, $uibModal, $timeout, TemplateService, FormBuilderService, TokenRefreshService, FlashService, TBService, $location, AuthService, $scope, UrlClipCopy) {
    'ngInject';

    Object.assign(this, { $location, $window, $state, $uibModal, $timeout, TemplateService, TBService, FlashService, FormBuilderService, AuthService, TokenRefreshService, UrlClipCopy });

    this.listItems = [];
    this.visibleListItems = [];
    this.templateFolders = [];
    this.granted = [];
    this.pendingDelete = [];
    this.$scope = $scope;
    this.loadingNote = 'Loading Templates...';
    this.updatingItems = false;

    this.sortKey = 'updatedAt';
    this.sortReverse = true;
    this.templateColumns = [];
    this.activeFolderId = "";
    this.searchTerm = "";
    this.templateRowContextMenu = [
      {
        text: 'Open builder',
        visible: (record) => record && record.type !== 'folder',
        action: (record) => this.openTemplateBuilderInNewTab(record),
      },
      {
        text: 'Open submit form',
        visible: (record) => record && record.type !== 'folder',
        action: (record) => this.openTemplateSubmitInNewTab(record),
      },
    ];
  }

  async $onInit() {
    let response;
    try {
      $('body').css('overflow-y', 'auto');
      [this.realm, this.PROVIDER, response] = await Promise.all([
        this.AuthService.realm(),
        this.AuthService.getProviderSettings(),
        this.TemplateService.getTemplateList()
      ]);
      this.templateFolders = response?.data?.folders || [];
      const folders = this.templateFolders.map(f => ({...f, type: "folder"}));
      this.listItems = [...folders, ...(response?.data?.templates || [])];
      this.restoreActiveFolder();
      this.setColumns();
      this.setVisibleListItems();
      this.exporting = {};
      this.toggling = {};
      this.$scope.$watch('$ctrl.activeFolderId', _ => this.setVisibleListItems());
      this.$scope.$watch('$ctrl.searchTerm', _ => this.setVisibleListItems());
    } catch (error) {
      this.FlashService.error(error.message || error.toString());
      console.error(error);
    }

    this.loadingNote = '';
  }

  setColumns() {
    const cellStyle = {
      'text-align': 'left',
      'vertical-align': 'inherit'
    };

    this.templateColumns = [
      {
        'key': 'type',
        'header': '',
        'sortable': true,
        'tooltip': false,
        'style': {...cellStyle, "max-width": "40px", "width": "40px", "text-align": "center", "white-space": "nowrap"},
        'format': (_value, _format, record) => {
          if (record.type === 'folder') {
            return '<i class="fa fa-folder folder-icon" title="folder"></i>';
          }
          const icon = record.type === 'dynamic' ? 'fa-html5 template-icon' : 'fa-file-image-o template-icon';
          const typeTitle = `${record.type} template`;
          const signedIcon = record.signTemplate === true
            ? '<i class="fa fa-check signed-template-icon" title="Signed template"></i>'
            : '';
          return `<i class="fa ${icon}" title="${typeTitle}"></i>${signedIcon}`;
        },
        'onClick': (_, template) => template.type === "folder" ? this.openListElement(template) : console.log(template.id, template.type)
      },
      {
        'key': 'title',
        'header': 'Title',
        'sortable': true,
        'tooltip': (value) => value,
        'style': {...cellStyle, "width": "30%"},
        'format': (value, _index, record) => {
          if (!this.searchTerm || record.type === 'folder' || !record.folderId) return value;
          const pathString = this.TemplateService.getFolderPathString(record.folderId, this.templateFolders);
          if (!pathString) return value;
          const folderId = record.folderId;
          return `<div>${value}<br/><span class="badge folder-path-link" data-folder-id="${folderId}">${pathString}</span></div>`;
        },
        'onClick': (_value, element, _index, event) => {
          if (event && event.target) {
            const target = event.target;
            if (target.classList && target.classList.contains('folder-path-link')) {
              const folderId = target.getAttribute('data-folder-id');
              if (folderId) {
                this.openFolderFromPath(folderId);
                if (event.stopPropagation) event.stopPropagation();
                return;
              }
            }
          }
          this.openListElement(element);
        }
      }, 
      {
        'key': 'description',
        'header': 'Description',
        'sortable': true,
        'tooltip': true,
        'style': {...cellStyle, "width": "auto"},
        'onClick': (_value, element) => this.openListElement(element)
      }, 
      {
        'key': 'createdByName',
        'header': 'Owner',
        'sortable': true,
        'tooltip': true,
        'style': {...cellStyle, "max-width": "200px", "width": "200px"},
        'format': (value) => { return value },
        'onClick': (_value, element) => this.openListElement(element)
      }, 
      {
        'key': 'active',
        'header': 'Active',
        'sortable': true,
        'style': { ...cellStyle, "max-width": "74px", "width": "74px", "text-align": "center" },
        'format': (_value, _format, record) => {
          if(record.type==="folder") return '';
          const classes = this.toggling[record.id] ? 'fa-refresh fa-spin' : 
            (record.active ? 'fa-check text-success' : 'fa-times text-danger');
          return `<i class="fa ${classes} text-muted"></i>`;
        },
        'onClick': (_value, template) => {
          if (template.type==="folder") return;
          this.toggleActive(template.id);
        }
      }, 
      {
        'key': 'updatedAt',
        'header': 'Updated',
        'sortable': true,
        'style': { ...cellStyle, "max-width": "98px", "width": "98px" },
        'format': (value) =>
          `<span>${value ? new Date(value).toLocaleDateString("en-US") : ''}</span>`,
        'onClick': (_value, element) => this.openListElement(element)
      }, 
      {
        'key': 'id',
        'header': '',
        'style': { ...cellStyle, "max-width": "40px", "width": "40px", "text-align": "center" },
        'isCheckbox': true,
        'matchCondition': (record) => (record.type==="folder") ? false : true,
      }
    ];

    if (this.PROVIDER.migrateTemplateToProvider) {
      this.templateColumns = [
        ...this.templateColumns.slice(0, 5),
        {
          'key': 'id',
          'header': 'Export',
          'style': { ...cellStyle, "max-width": "60px", "width": "60px" },
          'format': (value) => {
            const classes = (this.exporting[value] && this.PROVIDER.migrateTemplateToProvider) ? 
              'fa-refresh fa-spin' : 'fa-link';
            return `<i class="fa ${classes} text-muted"></i>`;
          },
          'onClick': (value, template) => this.exportTemplate(template, value)
        },
        ...this.templateColumns.slice(5)
      ];
    }
  }

  setVisibleListItems() {
    if (this.searchTerm) {
      this.visibleListItems = this.listItems;
      return;
    }

    const folderIds = new Set((this.templateFolders || []).map(f => f.id));
    if ((this.activeFolderId || '') === '') {
      // Root: include folders with no parent and templates with no folder or orphaned folderId
      this.visibleListItems = this.listItems.filter(t => {
        if (t.type === 'folder') return (!t.parentId || !folderIds.has(t.parentId));
        const fid = t.folderId || '';
        return fid === '' || !folderIds.has(fid);
      });
      this.syncActiveFolderState();
      return;
    }
    const activeId = this.activeFolderId || '';
    this.visibleListItems = this.listItems.filter(t => (t.folderId || '') === activeId || (t.parentId || '') === activeId);
    this.syncActiveFolderState();
  }

  onBreadcrumbClick(_folderId) {
    this.searchTerm = '';
  }

  openFolderFromPath(folderId) {
    this.activeFolderId = folderId;
    this.searchTerm = '';
  }

  openListElement(element) {
    const {id, type, active} = element;
    if (type === 'folder') {
      this.activeFolderId = id;
      this.searchTerm = '';
      return;
    }
    if (this.toggling[id]) {
      this.FlashService.error('Template is being updated. Please wait for the operation to complete.');
      return;
    }
    if (!active) {
      this.FlashService.error('Template is not active. Please activate the template to edit it.');
      return;
    }
    switch(type) {
      case 'dynamic':
        this.$state.go('app.dynamic-builder', { 'templateId': id });
        break;
      default:
        this.$state.go('app.template-builder', { 'templateId': id });
        break;
    }
  }

  showNewTemplate() {

    this.modal = this.$uibModal.open({
      templateUrl: "form-builder/new-template/new-template.component.html",
      controller: NewTemplateComponent.controller,
      bindToController: true,
      controllerAs: "$ctrl",
      backdrop: "static",
      keyboard: false,
      size: 'md'
    });
    this.modal.result.then(
      closed => true,
      canceled => this.cancelModal()
    );
  }

  onShowTemplateActions(selectedTemplates) {
    if(!selectedTemplates?.length) return;
    
    const templateCount = selectedTemplates.length;
    const templateText = templateCount === 1 ? 'template' : 'templates';
    this.selectedTemplates = selectedTemplates;
    this.modal = this.$uibModal.open({
      backdrop: 'static',
      template: `
        <div class="modal-header">
          <h4 class="modal-title">Folder Actions</h4>
        </div>
          <div class="modal-body">
            <p class="modal-title"><strong>${templateCount} ${templateText} selected</strong></p><hr/>
            <div ng-if="!$ctrl.updatingItems">
              <div style="width:100%;text-align:center;">
                <button type="button" class="btn btn-primary" ng-click="$ctrl.moveTemplatesToFolder()" style="margin-bottom:20px;width:50%;">
                  <i class="fa fa-folder"></i> Move
                </button>
              </div>
              <div class="btn-group btn-group-justified" role="group" style="margin-bottom:20px;">
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-default" ng-click="$ctrl.setTemplatesState(true)"><i class="fa fa-check text-success"></i> Activate</button>
                </div>
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-default" ng-click="$ctrl.setTemplatesState(false)"><i class="fa fa-ban text-danger"></i> Deactivate</button>
                </div>
              </div>
              <div style="width:100%;text-align:center;">
                <button type="button" class="btn btn-danger" ng-click="$ctrl.deleteTemplates()" style="margin-bottom:10px;width:50%;">
                  <i class="fa fa-trash"></i> Delete
                </button>
              </div>
            </div>
            <div ng-if="$ctrl.updatingItems" style="height:100px;">
              <loader></loader>
            </div>
          </div>
        <div class="modal-footer">
          <div class="btn-group btn-group-justified" role="group">
            <div class="btn-group" role="group">
              <button type="button" class="btn btn-warning" ng-click="$ctrl.closeModal()" ng-disabled="$ctrl.updatingItems">Cancel</button>
            </div>
          </div>
        </div>
      `,
      scope: this.$scope,
      size: 'sm'
    });
    const modalInstance = this.modal;
    this.bindModalResultCleanup(modalInstance);
  }

  deleteTemplates() {
    const templates = (this.selectedTemplates || [])
      .filter(t => t && t.id && t.type !== 'folder');

    if (!templates.length) {
      this.closeModal();
      return;
    }

    const actionsModal = this.modal;
    actionsModal?.close();
    this.openDeleteConfirmModal(templates);
  }

  openDeleteConfirmModal(templates) {
    this.templatesToDelete = templates;
    this.deleteProviderFields = true;
    this.hasSignedTemplatesToDelete = templates.some(t => t.signTemplate === true);
    const templateCount = templates.length;
    const templateText = templateCount === 1 ? 'template' : 'templates';

    this.modal = this.$uibModal.open({
      backdrop: 'static',
      template: `
        <div class="modal-header">
          <h4 class="modal-title">Delete ${templateCount} ${templateText}</h4>
        </div>
        <div class="modal-body">
          <p>Are you sure you want to delete ${templateCount} ${templateText}? This action cannot be undone.</p>
          <div ng-if="$ctrl.hasSignedTemplatesToDelete" class="checkbox" style="margin-top:12px;">
            <label>
              <input type="checkbox" ng-model="$ctrl.deleteProviderFields">
              Also delete link fields and webhooks in QuickBase
            </label>
          </div>
          <div ng-if="$ctrl.updatingItems" style="height:60px;margin-top:12px;">
            <loader></loader>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" ng-click="$ctrl.confirmDeleteTemplates()" ng-disabled="$ctrl.updatingItems">Delete</button>
          <button type="button" class="btn btn-default" ng-click="$ctrl.closeModal()" ng-disabled="$ctrl.updatingItems">Cancel</button>
        </div>
      `,
      scope: this.$scope,
      size: 'sm'
    });
    const modalInstance = this.modal;
    this.bindModalResultCleanup(modalInstance);
  }

  confirmDeleteTemplates() {
    const templates = this.templatesToDelete || [];
    const delTemplates = templates.map(t => ({
      id: t.id,
      delete: true,
      ...(this.hasSignedTemplatesToDelete && this.deleteProviderFields ? { deleteProviderFields: true } : {}),
    }));

    if (!delTemplates.length) {
      this.closeModal();
      return;
    }

    const templateCount = delTemplates.length;
    const templateText = templateCount === 1 ? 'template' : 'templates';

    this.updatingItems = true;
    this.TemplateService.templateWorkspaceUpdate({ payload: { templates: delTemplates } })
      .then((response) => {
        const deletedIds = new Set(delTemplates.map(t => t.id));
        this.listItems = this.listItems.filter(t => !deletedIds.has(t.id));
        this.setVisibleListItems();
        this.FlashService.success(`${templateCount} ${templateText} deleted successfully!`);
        const warnings = response?.data?.providerFieldWarnings;
        if (Array.isArray(warnings) && warnings.length) {
          this.FlashService.warning(warnings.join('\n'));
        }
        this.modal?.close();
      }, () => {
        this.FlashService.error('There was an error deleting the templates!');
      })
      .finally(() => {
        this.updatingItems = false;
      });
  }

  setTemplatesState(status) {
    const selTemplates = (this.selectedTemplates || [])
      .filter(t => t && t.id)
      .map(t => ({ id: t.id, active: status }));
    if (!selTemplates.length) { this.closeModal(); return; }
    
    this.updatingItems = true;
    this.TemplateService.templateWorkspaceUpdate({ payload: { templates: selTemplates } })
      .then(() => {
        const ids = new Set(selTemplates.map(t => t.id));
        this.listItems.forEach(t => { if (ids.has(t.id) && t.type !== 'folder') t.active = status; });
        this.setVisibleListItems();
        this.FlashService.success(`Templates ${status ? 'activated': 'deactivated'} successfully!`);
        this.modal?.close();
      }, () => {
        this.FlashService.error('There was an error activating the templates!');
      })
      .finally(() => {
        this.updatingItems = false;
      });
  }

  moveTemplatesToFolder() {
    this.modal?.close();
    this.openFolderSelectionModal();
  }

  openFolderSelectionModal() {
    const templateCount = this.selectedTemplates.length;
    const templateText = templateCount === 1 ? 'template' : 'templates';
    this.folderHierarchy = this.getFolderHierarchy();
    
    this.modal = this.$uibModal.open({
      backdrop: 'static',
      template: `
        <div class="modal-header">
          <h4 class="modal-title">Move ${templateCount} ${templateText} to folder</h4>
        </div>
          <div class="modal-body" style="max-height: 400px; overflow-y: auto;">
            <p><strong>Current folder:</strong> {{$ctrl.getCurrentFolderName()}}</p>
            <p><strong>Select destination folder:</strong></p>
          <div class="list-group" ng-if="!$ctrl.updatingItems">
            <a href="javascript:void(0)" class="list-group-item" 
               ng-click="$ctrl.selectFolder('')" ng-class="{'active': $ctrl.selectedFolderId == '', 'disabled': '' == $ctrl.activeFolderId}">
              <i class="fa fa-home"></i> Home
              <span ng-if="!$ctrl.activeFolderId" class="badge">Current</span>
            </a>
            <a href="javascript:void(0)" 
               ng-repeat="folder in $ctrl.folderHierarchy track by folder.id"
               class="list-group-item"  ng-click="$ctrl.selectFolder(folder.id)"
               ng-class="{'active': $ctrl.selectedFolderId == folder.id, 'disabled': folder.id == $ctrl.activeFolderId}"
               ng-style="{'padding-left': (folder.level * 20 + 15) + 'px'}"
               ng-disabled="folder.id === $ctrl.activeFolderId">
              <i class="fa fa-folder"></i>
              {{folder.title}}
              <span ng-if="folder.id == $ctrl.activeFolderId" class="badge">Current</span>
            </a>
          </div>
          <div ng-if="$ctrl.updatingItems" style="height:100px">
            <loader></loader>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.confirmMoveToFolder()"
            ng-disabled="(!$ctrl.selectedFolderId && $ctrl.selectedFolderId != '') || $ctrl.updatingItems">Move Here</button>
          <button type="button" class="btn btn-default" ng-click="$ctrl.closeModal()" ng-disabled="$ctrl.updatingItems">Cancel</button>
        </div>
      `,
      scope: this.$scope,
      size: 'md'
    });
    
    this.selectedFolderId = null;

    const modalInstance = this.modal;
    this.bindModalResultCleanup(modalInstance);
  }

  getCurrentFolderName() {
    if (!this.activeFolderId) return 'Root';
    const currentFolder = this.templateFolders?.find(folder => folder.id === this.activeFolderId);
    return currentFolder ? currentFolder.title : 'MISSING!';
  }

  getFolderHierarchy() {
    if (!this.templateFolders) return [];
    
    const buildHierarchy = (parentId = '', level = 0) => {
      const children = this.templateFolders
        .filter(folder => folder.parentId === parentId)
        .sort((a, b) => a.title.localeCompare(b.title));
      let result = [];
      
      children.forEach(folder => {
        result.push({
          id: folder.id,
          title: folder.title,
          parentId: folder.parentId,
          level: level
        });
        result = result.concat(buildHierarchy(folder.id, level + 1));
      });
      
      return result;
    };
    
    return buildHierarchy();
  }

  selectFolder(folderId) {
    if (folderId === this.activeFolderId) return;
    this.selectedFolderId = folderId;
  }

  confirmMoveToFolder() {
    if (this.selectedFolderId === null) return;
    const targetFolderId = this.selectedFolderId;
    const moveTemplates = (this.selectedTemplates || []).map(t => ({ id: t.id, folderId: targetFolderId }));
    if (!moveTemplates.length) {
      this.closeModal();
      return;
    }

    this.updatingItems = true;
    this.TemplateService.templateWorkspaceUpdate({
      payload: { templates: moveTemplates }
    }).then(() => {
      const movedIds = new Set(moveTemplates.map(t => t.id));
      this.listItems.forEach(t => {
        if (movedIds.has(t.id) && t.type !== 'folder') {
          t.folderId = targetFolderId;
        }
      });
      this.setVisibleListItems();
      this.FlashService.success(`Templates moved to folder successfully!`);
      this.closeModal();
    }, () => {
      this.FlashService.error('There was an error moving the templates!');
    }).finally(() => {
      this.updatingItems = false;
    });
  }

  closeModal() {
    this.modal?.close();
  }

  bindModalResultCleanup(modalInstance) {
    modalInstance.result.then(
      () => {
        if (this.modal === modalInstance) this.closeModal();
      },
      () => {
        if (this.modal === modalInstance) this.closeModal();
      }
    );
  }

  onNewFolder() {
    this.modal = this.$uibModal.open({
      backdrop: 'static',
      template: `
        <div class="modal-header">
          <h4 class="modal-title">New Folder</h4>
        </div>
        <div class="modal-body">
          <div ng-if="!$ctrl.updatingItems">
            <p><strong>Title</strong></p>
            <div class="form-group">
              <input type="text" class="form-control" ng-model="$ctrl.newFolderTitle" placeholder="Folder title" autofocus>
            </div>
            <div class="form-group">
              <label>Description</label>
              <textarea class="form-control" rows="3" ng-model="$ctrl.newFolderDescription" placeholder="Folder description" style="resize: none;"></textarea>
            </div>
          </div>
          <div ng-if="$ctrl.updatingItems" style="height:100px">
            <loader></loader>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.addSubFolder()" ng-disabled="$ctrl.updatingItems || !$ctrl.newFolderTitle || !$ctrl.newFolderTitle.trim()">Add</button>
          <button type="button" class="btn btn-default" ng-click="$ctrl.closeModal()" ng-disabled="$ctrl.updatingItems">Cancel</button>
        </div>
      `,
      scope: this.$scope,
      size: 'sm'
    });
    this.newFolderTitle = '';
    this.newFolderDescription = '';
    const modalInstance = this.modal;
    this.bindModalResultCleanup(modalInstance);
  }

  addSubFolder() {
    if (!this.newFolderTitle || !this.newFolderTitle.trim()) return;
    const title = this.newFolderTitle.trim();
    const description = (this.newFolderDescription || '').trim();
    const parentId = this.activeFolderId || '';
    const { displayName } = this.AuthService.getProfile();
    
    this.updatingItems = true;
    this.TemplateService.templateWorkspaceUpdate({
      payload: { folders: [{ title, description, parentId }] }
    }).then((res) => {
      const created = res?.data?.folders?.[0];
      if (!created) {
        this.FlashService.error('There was an error creating the folder!');
        return;
      }
      
      const newFolder = {
        id: created.id,
        title: created.title,
        description: created.description || description || '',
        parentId: created.parentId || '',
        type: 'folder',
        createdByName: displayName || 'Unknown',
        updatedAt: created.updatedAt || new Date().toISOString()
      };
      this.templateFolders = this.templateFolders.concat([{ id: newFolder.id, title: newFolder.title, description: newFolder.description, parentId: newFolder.parentId }]);
      this.listItems = [{...newFolder}, ...this.listItems];
      this.searchTerm = '';
      this.setVisibleListItems();
      this.FlashService.success(`Folder "${title}" added successfully!`);
      this.closeModal();
    }, () => {
      this.FlashService.error('There was an error creating the folder!');
    }).finally(() => {
      this.updatingItems = false;
    });
  }

  onFolderSettings() {
    const currentFolder = this.templateFolders?.find(f => f.id === this.activeFolderId);
    if (!currentFolder) {
      this.FlashService.error('No folder selected.');
      return;
    }

    this.modal = this.$uibModal.open({
      backdrop: 'static',
      template: `
        <div class="modal-header">
          <h4 class="modal-title">Folder Settings</h4>
        </div>
        <div class="modal-body">
          <div ng-if="!$ctrl.updatingItems" style="height:180px">
            <div class="form-group">
              <label>Title</label>
              <input type="text" class="form-control" ng-model="$ctrl.settingsFolderTitle" placeholder="Folder title" autofocus>
            </div>
            <div class="form-group">
              <label>Description</label>
              <textarea class="form-control" rows="3"ng-model="$ctrl.settingsFolderDescription" placeholder="Folder description" style="resize: none;"></textarea>
            </div>
          </div>
          <div ng-if="$ctrl.updatingItems" style="height:100px">
            <loader></loader>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.saveFolderSettings()" ng-disabled="$ctrl.updatingItems || !$ctrl.settingsFolderTitle || !$ctrl.settingsFolderTitle.trim()">Update</button>
          <button type="button" class="btn btn-default" ng-click="$ctrl.closeModal()" ng-disabled="$ctrl.updatingItems">Cancel</button>
        </div>
      `,
      scope: this.$scope,
      size: 'md'
    });

    this.settingsFolderTitle = currentFolder.title || '';
    this.settingsFolderDescription = currentFolder.description || '';
    const modalInstance = this.modal;
    this.bindModalResultCleanup(modalInstance);
  }

  saveFolderSettings() {
    const title = (this.settingsFolderTitle || '').trim();
    if (!title) return;
    const description = (this.settingsFolderDescription || '').trim();

    const folder = this.templateFolders?.find(f => f.id === this.activeFolderId);
    if (!folder) return;
    const parentId = folder.parentId || '';
    this.updatingItems = true;

    this.TemplateService.templateWorkspaceUpdate({
      payload: { folders: [{ id: folder.id, title, description, parentId }] }
    }).then((res) => {
      const updated = res?.data?.folders?.find(f => f.id === folder.id);
      folder.title = updated?.title || title;
      folder.description = updated?.description || description;

      const folderInTemplates = this.listItems?.find(t => t.type === 'folder' && t.id === folder.id);
      if (folderInTemplates) {
        folderInTemplates.title = folder.title;
        folderInTemplates.description = folder.description;
      }
      this.setVisibleListItems();
      this.FlashService.success('Folder settings saved!');
      this.closeModal();
    }, () => {
      this.FlashService.error('There was an error saving the folder!');
    }).finally(() => {
      this.updatingItems = false;
    });
  }

  onRemoveFolder() {
    const currentFolderName = this.getCurrentFolderName();
    const folderId = this.activeFolderId;
    const hasSubfolders = this.templateFolders?.some(f => f.parentId === folderId);
    const hasTemplates = this.listItems?.some(t => t.type !== 'folder' && (t.folderId || '') === (folderId || ''));

    if (hasSubfolders || hasTemplates) {
      const reason = hasSubfolders ? 'It contains subfolders!' : 'It contains templates!';
      this.FlashService.error(`Cannot delete folder. ${reason}.`);
      return;
    }

    this.modal = this.$uibModal.open({
      backdrop: 'static',
      template: `
        <div class="modal-header">
          <h4 class="modal-title">Delete Folder</h4>
        </div>
        <div class="modal-body">
          <div ng-if="!$ctrl.updatingItems">
            <div class="alert alert-danger" role="alert">Are you sure you want to delete folder <strong>${currentFolderName}</strong>?</div>
          </div>
          <div ng-if="$ctrl.updatingItems" style="height:100px">
            <loader></loader>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" ng-click="$ctrl.removeFolder()" ng-disabled="$ctrl.updatingItems">Delete</button>
          <button type="button" class="btn btn-default" ng-click="$ctrl.closeModal()" ng-disabled="$ctrl.updatingItems">Cancel</button>
        </div>
      `,
      scope: this.$scope,
      size: 'sm'
    });

    const modalInstance = this.modal;
    this.bindModalResultCleanup(modalInstance);
  }

  removeFolder() {
    const folderId = this.activeFolderId;
    if (!folderId) { this.closeModal(); return; }
    
    const hasSubfolders = this.templateFolders?.some(f => f.parentId === folderId);
    const hasTemplates = this.listItems?.some(t => t.type !== 'folder' && (t.folderId || '') === (folderId || ''));
    if (hasSubfolders || hasTemplates) {
      this.FlashService.error('Cannot delete folder because it contains subfolders or templates!');
      return;
    }
    this.updatingItems = true;

    this.TemplateService.templateWorkspaceUpdate({
      payload: { folders: [{ id: folderId, delete: true }] }
    }).then(() => {
      const parentFolderId = this.templateFolders?.find(f => f.id === folderId)?.parentId || '';
      this.templateFolders = this.templateFolders.filter(f => f.id !== folderId);
      this.listItems = this.listItems.filter(t => !(t.type === 'folder' && t.id === folderId));
      this.activeFolderId = parentFolderId;
      this.searchTerm = '';
      this.setVisibleListItems();
      this.FlashService.success('Folder deleted successfully!');
      this.closeModal();
    }, () => {
      this.FlashService.error(`There was an error deleting the folder, check that it's empty!`);
    }).finally(() => {
      this.updatingItems = false;
    });
  }

  toggleActive(templateId) {
    if (this.toggling[templateId]) return;
    this.toggling[templateId] = true;

    const rec = this.listItems.find(t => t.id === templateId && t.type !== 'folder');
    if (!rec) {
      delete this.toggling[templateId];
      return;
    }
    const nextActive = !rec.active;

    this.TemplateService.templateWorkspaceUpdate({ payload: { templates: [{ id: templateId, active: nextActive }] } })
      .then(() => {
        rec.active = nextActive;
        delete this.toggling[templateId];
        this.FlashService.success(`Template "${rec.title}" was ${nextActive ? 'activated' : 'deactivated'} successfully!`);
      }, () => {
        this.FlashService.error('There was an error updating the template!');
        delete this.toggling[templateId];
      });
  }

  async exportTemplate(template, templateId) {

    if (this.exporting[templateId]) return;
    if (this.PROVIDER.migrateTemplateToProvider) {
      if (!this.$window.confirm(`Exporting the template will create/update configuration for this template in the provider.\nContinue?`)) return;

      this.exporting[templateId] = true;
      this.FormBuilderService.exportTemplate(template, false)
        .then(response => {
          if (response.data.success == true) {
            this.FlashService.success('The template was exported successfully!');
          }
          else {
            this.FlashService.error('There was an error exporting the template!');
          }
          delete this.exporting[templateId];
        }, () => {
          this.FlashService.error('The provider returned an error while exporting the template!');
          delete this.exporting[templateId];
        });
    }
    else {
      this.$state.go('app.template-builder', { 'templateId': template.id, links: true });
    }
  }

  getActiveFolderStorage() {
    try {
      return this.$window.localStorage;
    } catch (_e) {
      console.error("Cannot get local storage!");
      return null;
    }
  }

  openTemplateBuilderInNewTab(record) {
    if (!record || record.type === 'folder') return;
    const { id, type, active } = record;
    if (this.toggling[id]) {
      this.FlashService.error('Template is being updated. Please wait for the operation to complete.');
      return;
    }
    if (!active) {
      this.FlashService.error('Template is not active. Please activate the template to edit it.');
      return;
    }
    const stateName = type === 'dynamic' ? 'app.dynamic-builder' : 'app.template-builder';
    const url = this.$state.href(stateName, { templateId: id });
    this.$window.open(url, '_blank', 'noopener,noreferrer');
  }

  openTemplateSubmitInNewTab(record) {
    if (!record || record.type === 'folder') return;
    let url;
    if (record.signTemplate === true) {
      const linkId = record.defaultTemplateLinkId;
      if (!linkId) {
        this.FlashService.error('No default link is configured for this template.');
        return;
      }
      url = this.UrlClipCopy.getUrlLinkUrl(record, linkId);
    } else {
      url = this.UrlClipCopy.getAddUrl(record);
    }
    this.$window.open(url, '_blank', 'noopener,noreferrer');
  }

  restoreActiveFolder() {
    const storage = this.getActiveFolderStorage();
    if (!storage) return;
    const saved = storage.getItem(ACTIVE_FOLDER_STORAGE_KEY);
    if (!saved) return;
    const folderExists = this.templateFolders.some(f => f.id === saved);
    if (folderExists) {
      this.activeFolderId = saved;
    } else {
      storage.removeItem(ACTIVE_FOLDER_STORAGE_KEY);
    }
  }

  syncActiveFolderState() {
    this.TemplateService.activeFolderId = this.activeFolderId || '';
    this.persistActiveFolder();
  }

  persistActiveFolder() {
    const storage = this.getActiveFolderStorage();
    if (!storage) return;
    try {
      if (this.activeFolderId) {
        storage.setItem(ACTIVE_FOLDER_STORAGE_KEY, this.activeFolderId);
      } else {
        storage.removeItem(ACTIVE_FOLDER_STORAGE_KEY);
      }
    } catch (_e) { console.error("Cannot store active folder!") }
  }
}

export default {
  bindings: {},
  templateUrl: 'form-builder/template-list/form-template-list.component.html',
  controller: FormTemplateListCtrl
};
